var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentificationBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 27.5,
    stroke: "url(#paint0_linear_14045_413)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14045_413",
    x1: 11.1522,
    y1: 51.2174,
    x2: 53.6957,
    y2: 3.30435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E700CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationBorder);
export default __webpack_public_path__ + "static/media/identification-border.3787fed613f3952c07ac1614b5ed93a3.svg";
export { ForwardRef as ReactComponent };